export default __webpack_public_path__ + "static/media/NotoSans-Regular.4f8b4ada.otf";